import { computed as e, isRef as t, nextTick as n, onMounted as r, onUnmounted as i, reactive as a, readonly as o, ref as s, toValue as c, unref as l, watch as u } from "vue";
import { defaultDocument as d, tryOnMounted as f, tryOnScopeDispose as p, unrefElement as m, watchPausable as h } from "@vueuse/core";
import { dayjs as ee, formatters as g, object as te } from "@myparcel-frontend/utils";
//#region ../../node_modules/.pnpm/sortablejs@1.15.7/node_modules/sortablejs/modular/sortable.esm.js
function _(e, t, n) {
	return (t = oe(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function v() {
	return v = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, v.apply(null, arguments);
}
function ne(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function re(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ne(Object(n), !0).forEach(function(t) {
			_(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ne(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function ie(e, t) {
	if (e == null) return {};
	var n, r, i = ae(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function ae(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function y(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function oe(e) {
	var t = y(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function se(e) {
	"@babel/helpers - typeof";
	return se = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, se(e);
}
var ce = "1.15.7";
function b(e) {
	if (typeof window < "u" && window.navigator) return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var x = b(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), le = b(/Edge/i), ue = b(/firefox/i), de = b(/safari/i) && !b(/chrome/i) && !b(/android/i), fe = b(/iP(ad|od|hone)/i), pe = b(/chrome/i) && b(/android/i), me = {
	capture: !1,
	passive: !1
};
function S(e, t, n) {
	e.addEventListener(t, n, !x && me);
}
function C(e, t, n) {
	e.removeEventListener(t, n, !x && me);
}
function he(e, t) {
	if (t) {
		if (t[0] === ">" && (t = t.substring(1)), e) try {
			if (e.matches) return e.matches(t);
			if (e.msMatchesSelector) return e.msMatchesSelector(t);
			if (e.webkitMatchesSelector) return e.webkitMatchesSelector(t);
		} catch {
			return !1;
		}
		return !1;
	}
}
function ge(e) {
	return e.host && e !== document && e.host.nodeType && e.host !== e ? e.host : e.parentNode;
}
function _e(e, t, n, r) {
	if (e) {
		n ||= document;
		do {
			if (t != null && (t[0] === ">" ? e.parentNode === n && he(e, t) : he(e, t)) || r && e === n) return e;
			if (e === n) break;
		} while (e = ge(e));
	}
	return null;
}
var ve = /\s+/g;
function ye(e, t, n) {
	e && t && (e.classList ? e.classList[n ? "add" : "remove"](t) : e.className = ((" " + e.className + " ").replace(ve, " ").replace(" " + t + " ", " ") + (n ? " " + t : "")).replace(ve, " "));
}
function w(e, t, n) {
	var r = e && e.style;
	if (r) {
		if (n === void 0) return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
		!(t in r) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), r[t] = n + (typeof n == "string" ? "" : "px");
	}
}
function be(e, t) {
	var n = "";
	if (typeof e == "string") n = e;
	else do {
		var r = w(e, "transform");
		r && r !== "none" && (n = r + " " + n);
	} while (!t && (e = e.parentNode));
	var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
	return i && new i(n);
}
function xe(e, t, n) {
	if (e) {
		var r = e.getElementsByTagName(t), i = 0, a = r.length;
		if (n) for (; i < a; i++) n(r[i], i);
		return r;
	}
	return [];
}
function Se() {
	return document.scrollingElement || document.documentElement;
}
function T(e, t, n, r, i) {
	if (!(!e.getBoundingClientRect && e !== window)) {
		var a, o, s, c, l, u, d;
		if (e !== window && e.parentNode && e !== Se() ? (a = e.getBoundingClientRect(), o = a.top, s = a.left, c = a.bottom, l = a.right, u = a.height, d = a.width) : (o = 0, s = 0, c = window.innerHeight, l = window.innerWidth, u = window.innerHeight, d = window.innerWidth), (t || n) && e !== window && (i ||= e.parentNode, !x)) do
			if (i && i.getBoundingClientRect && (w(i, "transform") !== "none" || n && w(i, "position") !== "static")) {
				var f = i.getBoundingClientRect();
				o -= f.top + parseInt(w(i, "border-top-width")), s -= f.left + parseInt(w(i, "border-left-width")), c = o + a.height, l = s + a.width;
				break;
			}
		while (i = i.parentNode);
		if (r && e !== window) {
			var p = be(i || e), m = p && p.a, h = p && p.d;
			p && (o /= h, s /= m, d /= m, u /= h, c = o + u, l = s + d);
		}
		return {
			top: o,
			left: s,
			bottom: c,
			right: l,
			width: d,
			height: u
		};
	}
}
function Ce(e, t, n) {
	for (var r = ke(e, !0), i = T(e)[t]; r;) {
		var a = T(r)[n], o = void 0;
		if (o = n === "top" || n === "left" ? i >= a : i <= a, !o) return r;
		if (r === Se()) break;
		r = ke(r, !1);
	}
	return !1;
}
function we(e, t, n, r) {
	for (var i = 0, a = 0, o = e.children; a < o.length;) {
		if (o[a].style.display !== "none" && o[a] !== I.ghost && (r || o[a] !== I.dragged) && _e(o[a], n.draggable, e, !1)) {
			if (i === t) return o[a];
			i++;
		}
		a++;
	}
	return null;
}
function Te(e, t) {
	for (var n = e.lastElementChild; n && (n === I.ghost || w(n, "display") === "none" || t && !he(n, t));) n = n.previousElementSibling;
	return n || null;
}
function Ee(e, t) {
	var n = 0;
	if (!e || !e.parentNode) return -1;
	for (; e = e.previousElementSibling;) e.nodeName.toUpperCase() !== "TEMPLATE" && e !== I.clone && (!t || he(e, t)) && n++;
	return n;
}
function De(e) {
	var t = 0, n = 0, r = Se();
	if (e) do {
		var i = be(e), a = i.a, o = i.d;
		t += e.scrollLeft * a, n += e.scrollTop * o;
	} while (e !== r && (e = e.parentNode));
	return [t, n];
}
function Oe(e, t) {
	for (var n in e) if (e.hasOwnProperty(n)) {
		for (var r in t) if (t.hasOwnProperty(r) && t[r] === e[n][r]) return Number(n);
	}
	return -1;
}
function ke(e, t) {
	if (!e || !e.getBoundingClientRect) return Se();
	var n = e, r = !1;
	do
		if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
			var i = w(n);
			if (n.clientWidth < n.scrollWidth && (i.overflowX == "auto" || i.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (i.overflowY == "auto" || i.overflowY == "scroll")) {
				if (!n.getBoundingClientRect || n === document.body) return Se();
				if (r || t) return n;
				r = !0;
			}
		}
	while (n = n.parentNode);
	return Se();
}
function Ae(e, t) {
	if (e && t) for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
	return e;
}
function je(e, t) {
	return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var Me;
function Ne(e, t) {
	return function() {
		if (!Me) {
			var n = arguments, r = this;
			n.length === 1 ? e.call(r, n[0]) : e.apply(r, n), Me = setTimeout(function() {
				Me = void 0;
			}, t);
		}
	};
}
function Pe() {
	clearTimeout(Me), Me = void 0;
}
function Fe(e, t, n) {
	e.scrollLeft += t, e.scrollTop += n;
}
function Ie(e) {
	var t = window.Polymer, n = window.jQuery || window.Zepto;
	return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
function Le(e, t, n) {
	var r = {};
	return Array.from(e.children).forEach(function(i) {
		if (!(!_e(i, t.draggable, e, !1) || i.animated || i === n)) {
			var a = T(i);
			r.left = Math.min(r.left ?? Infinity, a.left), r.top = Math.min(r.top ?? Infinity, a.top), r.right = Math.max(r.right ?? -Infinity, a.right), r.bottom = Math.max(r.bottom ?? -Infinity, a.bottom);
		}
	}), r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
var E = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Re() {
	var e = [], t;
	return {
		captureAnimationState: function() {
			e = [], this.options.animation && [].slice.call(this.el.children).forEach(function(t) {
				if (!(w(t, "display") === "none" || t === I.ghost)) {
					e.push({
						target: t,
						rect: T(t)
					});
					var n = re({}, e[e.length - 1].rect);
					if (t.thisAnimationDuration) {
						var r = be(t, !0);
						r && (n.top -= r.f, n.left -= r.e);
					}
					t.fromRect = n;
				}
			});
		},
		addAnimationState: function(t) {
			e.push(t);
		},
		removeAnimationState: function(t) {
			e.splice(Oe(e, { target: t }), 1);
		},
		animateAll: function(n) {
			var r = this;
			if (!this.options.animation) {
				clearTimeout(t), typeof n == "function" && n();
				return;
			}
			var i = !1, a = 0;
			e.forEach(function(e) {
				var t = 0, n = e.target, o = n.fromRect, s = T(n), c = n.prevFromRect, l = n.prevToRect, u = e.rect, d = be(n, !0);
				d && (s.top -= d.f, s.left -= d.e), n.toRect = s, n.thisAnimationDuration && je(c, s) && !je(o, s) && (u.top - s.top) / (u.left - s.left) === (o.top - s.top) / (o.left - s.left) && (t = Be(u, c, l, r.options)), je(s, o) || (n.prevFromRect = o, n.prevToRect = s, t ||= r.options.animation, r.animate(n, u, s, t)), t && (i = !0, a = Math.max(a, t), clearTimeout(n.animationResetTimer), n.animationResetTimer = setTimeout(function() {
					n.animationTime = 0, n.prevFromRect = null, n.fromRect = null, n.prevToRect = null, n.thisAnimationDuration = null;
				}, t), n.thisAnimationDuration = t);
			}), clearTimeout(t), i ? t = setTimeout(function() {
				typeof n == "function" && n();
			}, a) : typeof n == "function" && n(), e = [];
		},
		animate: function(e, t, n, r) {
			if (r) {
				w(e, "transition", ""), w(e, "transform", "");
				var i = be(this.el), a = i && i.a, o = i && i.d, s = (t.left - n.left) / (a || 1), c = (t.top - n.top) / (o || 1);
				e.animatingX = !!s, e.animatingY = !!c, w(e, "transform", "translate3d(" + s + "px," + c + "px,0)"), this.forRepaintDummy = ze(e), w(e, "transition", "transform " + r + "ms" + (this.options.easing ? " " + this.options.easing : "")), w(e, "transform", "translate3d(0,0,0)"), typeof e.animated == "number" && clearTimeout(e.animated), e.animated = setTimeout(function() {
					w(e, "transition", ""), w(e, "transform", ""), e.animated = !1, e.animatingX = !1, e.animatingY = !1;
				}, r);
			}
		}
	};
}
function ze(e) {
	return e.offsetWidth;
}
function Be(e, t, n, r) {
	return Math.sqrt((t.top - e.top) ** 2 + (t.left - e.left) ** 2) / Math.sqrt((t.top - n.top) ** 2 + (t.left - n.left) ** 2) * r.animation;
}
var Ve = [], He = { initializeByDefault: !0 }, Ue = {
	mount: function(e) {
		for (var t in He) He.hasOwnProperty(t) && !(t in e) && (e[t] = He[t]);
		Ve.forEach(function(t) {
			if (t.pluginName === e.pluginName) throw `Sortable: Cannot mount plugin ${e.pluginName} more than once`;
		}), Ve.push(e);
	},
	pluginEvent: function(e, t, n) {
		var r = this;
		this.eventCanceled = !1, n.cancel = function() {
			r.eventCanceled = !0;
		};
		var i = e + "Global";
		Ve.forEach(function(r) {
			t[r.pluginName] && (t[r.pluginName][i] && t[r.pluginName][i](re({ sortable: t }, n)), t.options[r.pluginName] && t[r.pluginName][e] && t[r.pluginName][e](re({ sortable: t }, n)));
		});
	},
	initializePlugins: function(e, t, n, r) {
		for (var i in Ve.forEach(function(r) {
			var i = r.pluginName;
			if (!(!e.options[i] && !r.initializeByDefault)) {
				var a = new r(e, t, e.options);
				a.sortable = e, a.options = e.options, e[i] = a, v(n, a.defaults);
			}
		}), e.options) if (e.options.hasOwnProperty(i)) {
			var a = this.modifyOption(e, i, e.options[i]);
			a !== void 0 && (e.options[i] = a);
		}
	},
	getEventProperties: function(e, t) {
		var n = {};
		return Ve.forEach(function(r) {
			typeof r.eventProperties == "function" && v(n, r.eventProperties.call(t[r.pluginName], e));
		}), n;
	},
	modifyOption: function(e, t, n) {
		var r;
		return Ve.forEach(function(i) {
			e[i.pluginName] && i.optionListeners && typeof i.optionListeners[t] == "function" && (r = i.optionListeners[t].call(e[i.pluginName], n));
		}), r;
	}
};
function We(e) {
	var t = e.sortable, n = e.rootEl, r = e.name, i = e.targetEl, a = e.cloneEl, o = e.toEl, s = e.fromEl, c = e.oldIndex, l = e.newIndex, u = e.oldDraggableIndex, d = e.newDraggableIndex, f = e.originalEvent, p = e.putSortable, m = e.extraEventProperties;
	if (t ||= n && n[E], t) {
		var h, ee = t.options, g = "on" + r.charAt(0).toUpperCase() + r.substr(1);
		window.CustomEvent && !x && !le ? h = new CustomEvent(r, {
			bubbles: !0,
			cancelable: !0
		}) : (h = document.createEvent("Event"), h.initEvent(r, !0, !0)), h.to = o || n, h.from = s || n, h.item = i || n, h.clone = a, h.oldIndex = c, h.newIndex = l, h.oldDraggableIndex = u, h.newDraggableIndex = d, h.originalEvent = f, h.pullMode = p ? p.lastPutMode : void 0;
		var te = re(re({}, m), Ue.getEventProperties(r, t));
		for (var _ in te) h[_] = te[_];
		n && n.dispatchEvent(h), ee[g] && ee[g].call(t, h);
	}
}
var Ge = ["evt"], D = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.evt, i = ie(n, Ge);
	Ue.pluginEvent.bind(I)(e, t, re({
		dragEl: k,
		parentEl: A,
		ghostEl: j,
		rootEl: M,
		nextEl: Ke,
		lastDownEl: qe,
		cloneEl: N,
		cloneHidden: Je,
		dragStarted: lt,
		putSortable: P,
		activeSortable: I.active,
		originalEvent: r,
		oldIndex: Ye,
		oldDraggableIndex: Ze,
		newIndex: Xe,
		newDraggableIndex: Qe,
		hideGhostForTarget: Dt,
		unhideGhostForTarget: Ot,
		cloneNowHidden: function() {
			Je = !0;
		},
		cloneNowShown: function() {
			Je = !1;
		},
		dispatchSortableEvent: function(e) {
			O({
				sortable: t,
				name: e,
				originalEvent: r
			});
		}
	}, i));
};
function O(e) {
	We(re({
		putSortable: P,
		cloneEl: N,
		targetEl: k,
		rootEl: M,
		oldIndex: Ye,
		oldDraggableIndex: Ze,
		newIndex: Xe,
		newDraggableIndex: Qe
	}, e));
}
var k, A, j, M, Ke, qe, N, Je, Ye, Xe, Ze, Qe, $e, P, et = !1, tt = !1, nt = [], rt, it, at, ot, st, ct, lt, ut, dt, ft = !1, pt = !1, mt, F, ht = [], gt = !1, _t = [], vt = typeof document < "u", yt = fe, bt = le || x ? "cssFloat" : "float", xt = vt && !pe && !fe && "draggable" in document.createElement("div"), St = function() {
	if (vt) {
		if (x) return !1;
		var e = document.createElement("x");
		return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
	}
}(), Ct = function(e, t) {
	var n = w(e), r = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), i = we(e, 0, t), a = we(e, 1, t), o = i && w(i), s = a && w(a), c = o && parseInt(o.marginLeft) + parseInt(o.marginRight) + T(i).width, l = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + T(a).width;
	if (n.display === "flex") return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
	if (n.display === "grid") return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
	if (i && o.float && o.float !== "none") {
		var u = o.float === "left" ? "left" : "right";
		return a && (s.clear === "both" || s.clear === u) ? "vertical" : "horizontal";
	}
	return i && (o.display === "block" || o.display === "flex" || o.display === "table" || o.display === "grid" || c >= r && n[bt] === "none" || a && n[bt] === "none" && c + l > r) ? "vertical" : "horizontal";
}, wt = function(e, t, n) {
	var r = n ? e.left : e.top, i = n ? e.right : e.bottom, a = n ? e.width : e.height, o = n ? t.left : t.top, s = n ? t.right : t.bottom, c = n ? t.width : t.height;
	return r === o || i === s || r + a / 2 === o + c / 2;
}, Tt = function(e, t) {
	var n;
	return nt.some(function(r) {
		var i = r[E].options.emptyInsertThreshold;
		if (!(!i || Te(r))) {
			var a = T(r), o = e >= a.left - i && e <= a.right + i, s = t >= a.top - i && t <= a.bottom + i;
			if (o && s) return n = r;
		}
	}), n;
}, Et = function(e) {
	function t(e, n) {
		return function(r, i, a, o) {
			var s = r.options.group.name && i.options.group.name && r.options.group.name === i.options.group.name;
			if (e == null && (n || s)) return !0;
			if (e == null || e === !1) return !1;
			if (n && e === "clone") return e;
			if (typeof e == "function") return t(e(r, i, a, o), n)(r, i, a, o);
			var c = (n ? r : i).options.group.name;
			return e === !0 || typeof e == "string" && e === c || e.join && e.indexOf(c) > -1;
		};
	}
	var n = {}, r = e.group;
	(!r || se(r) != "object") && (r = { name: r }), n.name = r.name, n.checkPull = t(r.pull, !0), n.checkPut = t(r.put), n.revertClone = r.revertClone, e.group = n;
}, Dt = function() {
	!St && j && w(j, "display", "none");
}, Ot = function() {
	!St && j && w(j, "display", "");
};
vt && !pe && document.addEventListener("click", function(e) {
	if (tt) return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), tt = !1, !1;
}, !0);
var kt = function(e) {
	if (k) {
		e = e.touches ? e.touches[0] : e;
		var t = Tt(e.clientX, e.clientY);
		if (t) {
			var n = {};
			for (var r in e) e.hasOwnProperty(r) && (n[r] = e[r]);
			n.target = n.rootEl = t, n.preventDefault = void 0, n.stopPropagation = void 0, t[E]._onDragOver(n);
		}
	}
}, At = function(e) {
	k && k.parentNode[E]._isOutsideThisEl(e.target);
};
function I(e, t) {
	if (!(e && e.nodeType && e.nodeType === 1)) throw `Sortable: \`el\` must be an HTMLElement, not ${{}.toString.call(e)}`;
	this.el = e, this.options = t = v({}, t), e[E] = this;
	var n = {
		group: null,
		sort: !0,
		disabled: !1,
		store: null,
		handle: null,
		draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
		swapThreshold: 1,
		invertSwap: !1,
		invertedSwapThreshold: null,
		removeCloneOnHide: !0,
		direction: function() {
			return Ct(e, this.options);
		},
		ghostClass: "sortable-ghost",
		chosenClass: "sortable-chosen",
		dragClass: "sortable-drag",
		ignore: "a, img",
		filter: null,
		preventOnFilter: !0,
		animation: 0,
		easing: null,
		setData: function(e, t) {
			e.setData("Text", t.textContent);
		},
		dropBubble: !1,
		dragoverBubble: !1,
		dataIdAttr: "data-id",
		delay: 0,
		delayOnTouchOnly: !1,
		touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
		forceFallback: !1,
		fallbackClass: "sortable-fallback",
		fallbackOnBody: !1,
		fallbackTolerance: 0,
		fallbackOffset: {
			x: 0,
			y: 0
		},
		supportPointer: I.supportPointer !== !1 && "PointerEvent" in window && (!de || fe),
		emptyInsertThreshold: 5
	};
	for (var r in Ue.initializePlugins(this, e, n), n) !(r in t) && (t[r] = n[r]);
	for (var i in Et(t), this) i.charAt(0) === "_" && typeof this[i] == "function" && (this[i] = this[i].bind(this));
	this.nativeDraggable = t.forceFallback ? !1 : xt, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? S(e, "pointerdown", this._onTapStart) : (S(e, "mousedown", this._onTapStart), S(e, "touchstart", this._onTapStart)), this.nativeDraggable && (S(e, "dragover", this), S(e, "dragenter", this)), nt.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), v(this, Re());
}
I.prototype = {
	constructor: I,
	_isOutsideThisEl: function(e) {
		!this.el.contains(e) && e !== this.el && (ut = null);
	},
	_getDirection: function(e, t) {
		return typeof this.options.direction == "function" ? this.options.direction.call(this, e, t, k) : this.options.direction;
	},
	_onTapStart: function(e) {
		if (e.cancelable) {
			var t = this, n = this.el, r = this.options, i = r.preventOnFilter, a = e.type, o = e.touches && e.touches[0] || e.pointerType && e.pointerType === "touch" && e, s = (o || e).target, c = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || s, l = r.filter;
			if (Bt(n), !k && !(/mousedown|pointerdown/.test(a) && e.button !== 0 || r.disabled) && !c.isContentEditable && !(!this.nativeDraggable && de && s && s.tagName.toUpperCase() === "SELECT") && (s = _e(s, r.draggable, n, !1), !(s && s.animated) && qe !== s)) {
				if (Ye = Ee(s), Ze = Ee(s, r.draggable), typeof l == "function") {
					if (l.call(this, e, s, this)) {
						O({
							sortable: t,
							rootEl: c,
							name: "filter",
							targetEl: s,
							toEl: n,
							fromEl: n
						}), D("filter", t, { evt: e }), i && e.preventDefault();
						return;
					}
				} else if (l && (l = l.split(",").some(function(r) {
					if (r = _e(c, r.trim(), n, !1), r) return O({
						sortable: t,
						rootEl: r,
						name: "filter",
						targetEl: s,
						fromEl: n,
						toEl: n
					}), D("filter", t, { evt: e }), !0;
				}), l)) {
					i && e.preventDefault();
					return;
				}
				r.handle && !_e(c, r.handle, n, !1) || this._prepareDragStart(e, o, s);
			}
		}
	},
	_prepareDragStart: function(e, t, n) {
		var r = this, i = r.el, a = r.options, o = i.ownerDocument, s;
		if (n && !k && n.parentNode === i) {
			var c = T(n);
			if (M = i, k = n, A = k.parentNode, Ke = k.nextSibling, qe = n, $e = a.group, I.dragged = k, rt = {
				target: k,
				clientX: (t || e).clientX,
				clientY: (t || e).clientY
			}, st = rt.clientX - c.left, ct = rt.clientY - c.top, this._lastX = (t || e).clientX, this._lastY = (t || e).clientY, k.style["will-change"] = "all", s = function() {
				if (D("delayEnded", r, { evt: e }), I.eventCanceled) {
					r._onDrop();
					return;
				}
				r._disableDelayedDragEvents(), !ue && r.nativeDraggable && (k.draggable = !0), r._triggerDragStart(e, t), O({
					sortable: r,
					name: "choose",
					originalEvent: e
				}), ye(k, a.chosenClass, !0);
			}, a.ignore.split(",").forEach(function(e) {
				xe(k, e.trim(), Nt);
			}), S(o, "dragover", kt), S(o, "mousemove", kt), S(o, "touchmove", kt), a.supportPointer ? (S(o, "pointerup", r._onDrop), !this.nativeDraggable && S(o, "pointercancel", r._onDrop)) : (S(o, "mouseup", r._onDrop), S(o, "touchend", r._onDrop), S(o, "touchcancel", r._onDrop)), ue && this.nativeDraggable && (this.options.touchStartThreshold = 4, k.draggable = !0), D("delayStart", this, { evt: e }), a.delay && (!a.delayOnTouchOnly || t) && (!this.nativeDraggable || !(le || x))) {
				if (I.eventCanceled) {
					this._onDrop();
					return;
				}
				a.supportPointer ? (S(o, "pointerup", r._disableDelayedDrag), S(o, "pointercancel", r._disableDelayedDrag)) : (S(o, "mouseup", r._disableDelayedDrag), S(o, "touchend", r._disableDelayedDrag), S(o, "touchcancel", r._disableDelayedDrag)), S(o, "mousemove", r._delayedDragTouchMoveHandler), S(o, "touchmove", r._delayedDragTouchMoveHandler), a.supportPointer && S(o, "pointermove", r._delayedDragTouchMoveHandler), r._dragStartTimer = setTimeout(s, a.delay);
			} else s();
		}
	},
	_delayedDragTouchMoveHandler: function(e) {
		var t = e.touches ? e.touches[0] : e;
		Math.max(Math.abs(t.clientX - this._lastX), Math.abs(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
	},
	_disableDelayedDrag: function() {
		k && Nt(k), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
	},
	_disableDelayedDragEvents: function() {
		var e = this.el.ownerDocument;
		C(e, "mouseup", this._disableDelayedDrag), C(e, "touchend", this._disableDelayedDrag), C(e, "touchcancel", this._disableDelayedDrag), C(e, "pointerup", this._disableDelayedDrag), C(e, "pointercancel", this._disableDelayedDrag), C(e, "mousemove", this._delayedDragTouchMoveHandler), C(e, "touchmove", this._delayedDragTouchMoveHandler), C(e, "pointermove", this._delayedDragTouchMoveHandler);
	},
	_triggerDragStart: function(e, t) {
		t ||= e.pointerType == "touch" && e, !this.nativeDraggable || t ? this.options.supportPointer ? S(document, "pointermove", this._onTouchMove) : t ? S(document, "touchmove", this._onTouchMove) : S(document, "mousemove", this._onTouchMove) : (S(k, "dragend", this), S(M, "dragstart", this._onDragStart));
		try {
			document.selection ? Vt(function() {
				document.selection.empty();
			}) : window.getSelection().removeAllRanges();
		} catch {}
	},
	_dragStarted: function(e, t) {
		if (et = !1, M && k) {
			D("dragStarted", this, { evt: t }), this.nativeDraggable && S(document, "dragover", At);
			var n = this.options;
			!e && ye(k, n.dragClass, !1), ye(k, n.ghostClass, !0), I.active = this, e && this._appendGhost(), O({
				sortable: this,
				name: "start",
				originalEvent: t
			});
		} else this._nulling();
	},
	_emulateDragOver: function() {
		if (it) {
			this._lastX = it.clientX, this._lastY = it.clientY, Dt();
			for (var e = document.elementFromPoint(it.clientX, it.clientY), t = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(it.clientX, it.clientY), e !== t);) t = e;
			if (k.parentNode[E]._isOutsideThisEl(e), t) do {
				if (t[E]) {
					var n = void 0;
					if (n = t[E]._onDragOver({
						clientX: it.clientX,
						clientY: it.clientY,
						target: e,
						rootEl: t
					}), n && !this.options.dragoverBubble) break;
				}
				e = t;
			} while (t = ge(t));
			Ot();
		}
	},
	_onTouchMove: function(e) {
		if (rt) {
			var t = this.options, n = t.fallbackTolerance, r = t.fallbackOffset, i = e.touches ? e.touches[0] : e, a = j && be(j, !0), o = j && a && a.a, s = j && a && a.d, c = yt && F && De(F), l = (i.clientX - rt.clientX + r.x) / (o || 1) + (c ? c[0] - ht[0] : 0) / (o || 1), u = (i.clientY - rt.clientY + r.y) / (s || 1) + (c ? c[1] - ht[1] : 0) / (s || 1);
			if (!I.active && !et) {
				if (n && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < n) return;
				this._onDragStart(e, !0);
			}
			if (j) {
				a ? (a.e += l - (at || 0), a.f += u - (ot || 0)) : a = {
					a: 1,
					b: 0,
					c: 0,
					d: 1,
					e: l,
					f: u
				};
				var d = `matrix(${a.a},${a.b},${a.c},${a.d},${a.e},${a.f})`;
				w(j, "webkitTransform", d), w(j, "mozTransform", d), w(j, "msTransform", d), w(j, "transform", d), at = l, ot = u, it = i;
			}
			e.cancelable && e.preventDefault();
		}
	},
	_appendGhost: function() {
		if (!j) {
			var e = this.options.fallbackOnBody ? document.body : M, t = T(k, !0, yt, !0, e), n = this.options;
			if (yt) {
				for (F = e; w(F, "position") === "static" && w(F, "transform") === "none" && F !== document;) F = F.parentNode;
				F !== document.body && F !== document.documentElement ? (F === document && (F = Se()), t.top += F.scrollTop, t.left += F.scrollLeft) : F = Se(), ht = De(F);
			}
			j = k.cloneNode(!0), ye(j, n.ghostClass, !1), ye(j, n.fallbackClass, !0), ye(j, n.dragClass, !0), w(j, "transition", ""), w(j, "transform", ""), w(j, "box-sizing", "border-box"), w(j, "margin", 0), w(j, "top", t.top), w(j, "left", t.left), w(j, "width", t.width), w(j, "height", t.height), w(j, "opacity", "0.8"), w(j, "position", yt ? "absolute" : "fixed"), w(j, "zIndex", "100000"), w(j, "pointerEvents", "none"), I.ghost = j, e.appendChild(j), w(j, "transform-origin", st / parseInt(j.style.width) * 100 + "% " + ct / parseInt(j.style.height) * 100 + "%");
		}
	},
	_onDragStart: function(e, t) {
		var n = this, r = e.dataTransfer, i = n.options;
		if (D("dragStart", this, { evt: e }), I.eventCanceled) {
			this._onDrop();
			return;
		}
		D("setupClone", this), I.eventCanceled || (N = Ie(k), N.removeAttribute("id"), N.draggable = !1, N.style["will-change"] = "", this._hideClone(), ye(N, this.options.chosenClass, !1), I.clone = N), n.cloneId = Vt(function() {
			D("clone", n), !I.eventCanceled && (n.options.removeCloneOnHide || M.insertBefore(N, k), n._hideClone(), O({
				sortable: n,
				name: "clone"
			}));
		}), !t && ye(k, i.dragClass, !0), t ? (tt = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (C(document, "mouseup", n._onDrop), C(document, "touchend", n._onDrop), C(document, "touchcancel", n._onDrop), r && (r.effectAllowed = "move", i.setData && i.setData.call(n, r, k)), S(document, "drop", n), w(k, "transform", "translateZ(0)")), et = !0, n._dragStartId = Vt(n._dragStarted.bind(n, t, e)), S(document, "selectstart", n), lt = !0, window.getSelection().removeAllRanges(), de && w(document.body, "user-select", "none");
	},
	_onDragOver: function(e) {
		var t = this.el, n = e.target, r, i, a, o = this.options, s = o.group, c = I.active, l = $e === s, u = o.sort, d = P || c, f, p = this, m = !1;
		if (gt) return;
		function h(o, s) {
			D(o, p, re({
				evt: e,
				isOwner: l,
				axis: f ? "vertical" : "horizontal",
				revert: a,
				dragRect: r,
				targetRect: i,
				canSort: u,
				fromSortable: d,
				target: n,
				completed: g,
				onMove: function(n, i) {
					return Mt(M, t, k, r, n, T(n), e, i);
				},
				changed: te
			}, s));
		}
		function ee() {
			h("dragOverAnimationCapture"), p.captureAnimationState(), p !== d && d.captureAnimationState();
		}
		function g(r) {
			return h("dragOverCompleted", { insertion: r }), r && (l ? c._hideClone() : c._showClone(p), p !== d && (ye(k, P ? P.options.ghostClass : c.options.ghostClass, !1), ye(k, o.ghostClass, !0)), P !== p && p !== I.active ? P = p : p === I.active && P && (P = null), d === p && (p._ignoreWhileAnimating = n), p.animateAll(function() {
				h("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
			}), p !== d && (d.animateAll(), d._ignoreWhileAnimating = null)), (n === k && !k.animated || n === t && !n.animated) && (ut = null), !o.dragoverBubble && !e.rootEl && n !== document && (k.parentNode[E]._isOutsideThisEl(e.target), !r && kt(e)), !o.dragoverBubble && e.stopPropagation && e.stopPropagation(), m = !0;
		}
		function te() {
			Xe = Ee(k), Qe = Ee(k, o.draggable), O({
				sortable: p,
				name: "change",
				toEl: t,
				newIndex: Xe,
				newDraggableIndex: Qe,
				originalEvent: e
			});
		}
		if (e.preventDefault !== void 0 && e.cancelable && e.preventDefault(), n = _e(n, o.draggable, t, !0), h("dragOver"), I.eventCanceled) return m;
		if (k.contains(e.target) || n.animated && n.animatingX && n.animatingY || p._ignoreWhileAnimating === n) return g(!1);
		if (tt = !1, c && !o.disabled && (l ? u || (a = A !== M) : P === this || (this.lastPutMode = $e.checkPull(this, c, k, e)) && s.checkPut(this, c, k, e))) {
			if (f = this._getDirection(e, n) === "vertical", r = T(k), h("dragOverValid"), I.eventCanceled) return m;
			if (a) return A = M, ee(), this._hideClone(), h("revert"), I.eventCanceled || (Ke ? M.insertBefore(k, Ke) : M.appendChild(k)), g(!0);
			var _ = Te(t, o.draggable);
			if (!_ || It(e, f, this) && !_.animated) {
				if (_ === k) return g(!1);
				if (_ && t === e.target && (n = _), n && (i = T(n)), Mt(M, t, k, r, n, i, e, !!n) !== !1) return ee(), _ && _.nextSibling ? t.insertBefore(k, _.nextSibling) : t.appendChild(k), A = t, te(), g(!0);
			} else if (_ && Ft(e, f, this)) {
				var v = we(t, 0, o, !0);
				if (v === k) return g(!1);
				if (n = v, i = T(n), Mt(M, t, k, r, n, i, e, !1) !== !1) return ee(), t.insertBefore(k, v), A = t, te(), g(!0);
			} else if (n.parentNode === t) {
				i = T(n);
				var ne = 0, ie, ae = k.parentNode !== t, y = !wt(k.animated && k.toRect || r, n.animated && n.toRect || i, f), oe = f ? "top" : "left", se = Ce(n, "top", "top") || Ce(k, "top", "top"), ce = se ? se.scrollTop : void 0;
				ut !== n && (ie = i[oe], ft = !1, pt = !y && o.invertSwap || ae), ne = Lt(e, n, i, f, y ? 1 : o.swapThreshold, o.invertedSwapThreshold == null ? o.swapThreshold : o.invertedSwapThreshold, pt, ut === n);
				var b;
				if (ne !== 0) {
					var x = Ee(k);
					do
						x -= ne, b = A.children[x];
					while (b && (w(b, "display") === "none" || b === j));
				}
				if (ne === 0 || b === n) return g(!1);
				ut = n, dt = ne;
				var le = n.nextElementSibling, ue = !1;
				ue = ne === 1;
				var de = Mt(M, t, k, r, n, i, e, ue);
				if (de !== !1) return (de === 1 || de === -1) && (ue = de === 1), gt = !0, setTimeout(Pt, 30), ee(), ue && !le ? t.appendChild(k) : n.parentNode.insertBefore(k, ue ? le : n), se && Fe(se, 0, ce - se.scrollTop), A = k.parentNode, ie !== void 0 && !pt && (mt = Math.abs(ie - T(n)[oe])), te(), g(!0);
			}
			if (t.contains(k)) return g(!1);
		}
		return !1;
	},
	_ignoreWhileAnimating: null,
	_offMoveEvents: function() {
		C(document, "mousemove", this._onTouchMove), C(document, "touchmove", this._onTouchMove), C(document, "pointermove", this._onTouchMove), C(document, "dragover", kt), C(document, "mousemove", kt), C(document, "touchmove", kt);
	},
	_offUpEvents: function() {
		var e = this.el.ownerDocument;
		C(e, "mouseup", this._onDrop), C(e, "touchend", this._onDrop), C(e, "pointerup", this._onDrop), C(e, "pointercancel", this._onDrop), C(e, "touchcancel", this._onDrop), C(document, "selectstart", this);
	},
	_onDrop: function(e) {
		var t = this.el, n = this.options;
		if (Xe = Ee(k), Qe = Ee(k, n.draggable), D("drop", this, { evt: e }), A = k && k.parentNode, Xe = Ee(k), Qe = Ee(k, n.draggable), I.eventCanceled) {
			this._nulling();
			return;
		}
		et = !1, pt = !1, ft = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Ht(this.cloneId), Ht(this._dragStartId), this.nativeDraggable && (C(document, "drop", this), C(t, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), de && w(document.body, "user-select", ""), w(k, "transform", ""), e && (lt && (e.cancelable && e.preventDefault(), !n.dropBubble && e.stopPropagation()), j && j.parentNode && j.parentNode.removeChild(j), (M === A || P && P.lastPutMode !== "clone") && N && N.parentNode && N.parentNode.removeChild(N), k && (this.nativeDraggable && C(k, "dragend", this), Nt(k), k.style["will-change"] = "", lt && !et && ye(k, P ? P.options.ghostClass : this.options.ghostClass, !1), ye(k, this.options.chosenClass, !1), O({
			sortable: this,
			name: "unchoose",
			toEl: A,
			newIndex: null,
			newDraggableIndex: null,
			originalEvent: e
		}), M === A ? Xe !== Ye && Xe >= 0 && (O({
			sortable: this,
			name: "update",
			toEl: A,
			originalEvent: e
		}), O({
			sortable: this,
			name: "sort",
			toEl: A,
			originalEvent: e
		})) : (Xe >= 0 && (O({
			rootEl: A,
			name: "add",
			toEl: A,
			fromEl: M,
			originalEvent: e
		}), O({
			sortable: this,
			name: "remove",
			toEl: A,
			originalEvent: e
		}), O({
			rootEl: A,
			name: "sort",
			toEl: A,
			fromEl: M,
			originalEvent: e
		}), O({
			sortable: this,
			name: "sort",
			toEl: A,
			originalEvent: e
		})), P && P.save()), I.active && ((Xe == null || Xe === -1) && (Xe = Ye, Qe = Ze), O({
			sortable: this,
			name: "end",
			toEl: A,
			originalEvent: e
		}), this.save()))), this._nulling();
	},
	_nulling: function() {
		D("nulling", this), M = k = A = j = Ke = N = qe = Je = rt = it = lt = Xe = Qe = Ye = Ze = ut = dt = P = $e = I.dragged = I.ghost = I.clone = I.active = null;
		var e = this.el;
		_t.forEach(function(t) {
			e.contains(t) && (t.checked = !0);
		}), _t.length = at = ot = 0;
	},
	handleEvent: function(e) {
		switch (e.type) {
			case "drop":
			case "dragend":
				this._onDrop(e);
				break;
			case "dragenter":
			case "dragover":
				k && (this._onDragOver(e), jt(e));
				break;
			case "selectstart":
				e.preventDefault();
				break;
		}
	},
	toArray: function() {
		for (var e = [], t, n = this.el.children, r = 0, i = n.length, a = this.options; r < i; r++) t = n[r], _e(t, a.draggable, this.el, !1) && e.push(t.getAttribute(a.dataIdAttr) || zt(t));
		return e;
	},
	sort: function(e, t) {
		var n = {}, r = this.el;
		this.toArray().forEach(function(e, t) {
			var i = r.children[t];
			_e(i, this.options.draggable, r, !1) && (n[e] = i);
		}, this), t && this.captureAnimationState(), e.forEach(function(e) {
			n[e] && (r.removeChild(n[e]), r.appendChild(n[e]));
		}), t && this.animateAll();
	},
	save: function() {
		var e = this.options.store;
		e && e.set && e.set(this);
	},
	closest: function(e, t) {
		return _e(e, t || this.options.draggable, this.el, !1);
	},
	option: function(e, t) {
		var n = this.options;
		if (t === void 0) return n[e];
		var r = Ue.modifyOption(this, e, t);
		r === void 0 ? n[e] = t : n[e] = r, e === "group" && Et(n);
	},
	destroy: function() {
		D("destroy", this);
		var e = this.el;
		e[E] = null, C(e, "mousedown", this._onTapStart), C(e, "touchstart", this._onTapStart), C(e, "pointerdown", this._onTapStart), this.nativeDraggable && (C(e, "dragover", this), C(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function(e) {
			e.removeAttribute("draggable");
		}), this._onDrop(), this._disableDelayedDragEvents(), nt.splice(nt.indexOf(this.el), 1), this.el = e = null;
	},
	_hideClone: function() {
		if (!Je) {
			if (D("hideClone", this), I.eventCanceled) return;
			w(N, "display", "none"), this.options.removeCloneOnHide && N.parentNode && N.parentNode.removeChild(N), Je = !0;
		}
	},
	_showClone: function(e) {
		if (e.lastPutMode !== "clone") {
			this._hideClone();
			return;
		}
		if (Je) {
			if (D("showClone", this), I.eventCanceled) return;
			k.parentNode == M && !this.options.group.revertClone ? M.insertBefore(N, k) : Ke ? M.insertBefore(N, Ke) : M.appendChild(N), this.options.group.revertClone && this.animate(k, N), w(N, "display", ""), Je = !1;
		}
	}
};
function jt(e) {
	e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Mt(e, t, n, r, i, a, o, s) {
	var c, l = e[E], u = l.options.onMove, d;
	return window.CustomEvent && !x && !le ? c = new CustomEvent("move", {
		bubbles: !0,
		cancelable: !0
	}) : (c = document.createEvent("Event"), c.initEvent("move", !0, !0)), c.to = t, c.from = e, c.dragged = n, c.draggedRect = r, c.related = i || t, c.relatedRect = a || T(t), c.willInsertAfter = s, c.originalEvent = o, e.dispatchEvent(c), u && (d = u.call(l, c, o)), d;
}
function Nt(e) {
	e.draggable = !1;
}
function Pt() {
	gt = !1;
}
function Ft(e, t, n) {
	var r = T(we(n.el, 0, n.options, !0)), i = Le(n.el, n.options, j), a = 10;
	return t ? e.clientX < i.left - a || e.clientY < r.top && e.clientX < r.right : e.clientY < i.top - a || e.clientY < r.bottom && e.clientX < r.left;
}
function It(e, t, n) {
	var r = T(Te(n.el, n.options.draggable)), i = Le(n.el, n.options, j), a = 10;
	return t ? e.clientX > i.right + a || e.clientY > r.bottom && e.clientX > r.left : e.clientY > i.bottom + a || e.clientX > r.right && e.clientY > r.top;
}
function Lt(e, t, n, r, i, a, o, s) {
	var c = r ? e.clientY : e.clientX, l = r ? n.height : n.width, u = r ? n.top : n.left, d = r ? n.bottom : n.right, f = !1;
	if (!o) {
		if (s && mt < l * i) {
			if (!ft && (dt === 1 ? c > u + l * a / 2 : c < d - l * a / 2) && (ft = !0), ft) f = !0;
			else if (dt === 1 ? c < u + mt : c > d - mt) return -dt;
		} else if (c > u + l * (1 - i) / 2 && c < d - l * (1 - i) / 2) return Rt(t);
	}
	return f ||= o, f && (c < u + l * a / 2 || c > d - l * a / 2) ? c > u + l / 2 ? 1 : -1 : 0;
}
function Rt(e) {
	return Ee(k) < Ee(e) ? 1 : -1;
}
function zt(e) {
	for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--;) r += t.charCodeAt(n);
	return r.toString(36);
}
function Bt(e) {
	_t.length = 0;
	for (var t = e.getElementsByTagName("input"), n = t.length; n--;) {
		var r = t[n];
		r.checked && _t.push(r);
	}
}
function Vt(e) {
	return setTimeout(e, 0);
}
function Ht(e) {
	return clearTimeout(e);
}
vt && S(document, "touchmove", function(e) {
	(I.active || et) && e.cancelable && e.preventDefault();
}), I.utils = {
	on: S,
	off: C,
	css: w,
	find: xe,
	is: function(e, t) {
		return !!_e(e, t, e, !1);
	},
	extend: Ae,
	throttle: Ne,
	closest: _e,
	toggleClass: ye,
	clone: Ie,
	index: Ee,
	nextTick: Vt,
	cancelNextTick: Ht,
	detectDirection: Ct,
	getChild: we,
	expando: E
}, I.get = function(e) {
	return e[E];
}, I.mount = function() {
	var e = [...arguments];
	e[0].constructor === Array && (e = e[0]), e.forEach(function(e) {
		if (!e.prototype || !e.prototype.constructor) throw `Sortable: Mounted plugin must be a constructor function, not ${{}.toString.call(e)}`;
		e.utils && (I.utils = re(re({}, I.utils), e.utils)), Ue.mount(e);
	});
}, I.create = function(e, t) {
	return new I(e, t);
}, I.version = ce;
var L = [], Ut, Wt, Gt = !1, Kt, qt, Jt, Yt;
function Xt() {
	function e() {
		for (var e in this.defaults = {
			scroll: !0,
			forceAutoScrollFallback: !1,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			bubbleScroll: !0
		}, this) e.charAt(0) === "_" && typeof this[e] == "function" && (this[e] = this[e].bind(this));
	}
	return e.prototype = {
		dragStarted: function(e) {
			var t = e.originalEvent;
			this.sortable.nativeDraggable ? S(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? S(document, "pointermove", this._handleFallbackAutoScroll) : t.touches ? S(document, "touchmove", this._handleFallbackAutoScroll) : S(document, "mousemove", this._handleFallbackAutoScroll);
		},
		dragOverCompleted: function(e) {
			var t = e.originalEvent;
			!this.options.dragOverBubble && !t.rootEl && this._handleAutoScroll(t);
		},
		drop: function() {
			this.sortable.nativeDraggable ? C(document, "dragover", this._handleAutoScroll) : (C(document, "pointermove", this._handleFallbackAutoScroll), C(document, "touchmove", this._handleFallbackAutoScroll), C(document, "mousemove", this._handleFallbackAutoScroll)), Qt(), Zt(), Pe();
		},
		nulling: function() {
			Jt = Wt = Ut = Gt = Yt = Kt = qt = null, L.length = 0;
		},
		_handleFallbackAutoScroll: function(e) {
			this._handleAutoScroll(e, !0);
		},
		_handleAutoScroll: function(e, t) {
			var n = this, r = (e.touches ? e.touches[0] : e).clientX, i = (e.touches ? e.touches[0] : e).clientY, a = document.elementFromPoint(r, i);
			if (Jt = e, t || this.options.forceAutoScrollFallback || le || x || de) {
				$t(e, this.options, a, t);
				var o = ke(a, !0);
				Gt && (!Yt || r !== Kt || i !== qt) && (Yt && Qt(), Yt = setInterval(function() {
					var a = ke(document.elementFromPoint(r, i), !0);
					a !== o && (o = a, Zt()), $t(e, n.options, a, t);
				}, 10), Kt = r, qt = i);
			} else {
				if (!this.options.bubbleScroll || ke(a, !0) === Se()) {
					Zt();
					return;
				}
				$t(e, this.options, ke(a, !1), !1);
			}
		}
	}, v(e, {
		pluginName: "scroll",
		initializeByDefault: !0
	});
}
function Zt() {
	L.forEach(function(e) {
		clearInterval(e.pid);
	}), L = [];
}
function Qt() {
	clearInterval(Yt);
}
var $t = Ne(function(e, t, n, r) {
	if (t.scroll) {
		var i = (e.touches ? e.touches[0] : e).clientX, a = (e.touches ? e.touches[0] : e).clientY, o = t.scrollSensitivity, s = t.scrollSpeed, c = Se(), l = !1, u;
		Wt !== n && (Wt = n, Zt(), Ut = t.scroll, u = t.scrollFn, Ut === !0 && (Ut = ke(n, !0)));
		var d = 0, f = Ut;
		do {
			var p = f, m = T(p), h = m.top, ee = m.bottom, g = m.left, te = m.right, _ = m.width, v = m.height, ne = void 0, re = void 0, ie = p.scrollWidth, ae = p.scrollHeight, y = w(p), oe = p.scrollLeft, se = p.scrollTop;
			p === c ? (ne = _ < ie && (y.overflowX === "auto" || y.overflowX === "scroll" || y.overflowX === "visible"), re = v < ae && (y.overflowY === "auto" || y.overflowY === "scroll" || y.overflowY === "visible")) : (ne = _ < ie && (y.overflowX === "auto" || y.overflowX === "scroll"), re = v < ae && (y.overflowY === "auto" || y.overflowY === "scroll"));
			var ce = ne && (Math.abs(te - i) <= o && oe + _ < ie) - (Math.abs(g - i) <= o && !!oe), b = re && (Math.abs(ee - a) <= o && se + v < ae) - (Math.abs(h - a) <= o && !!se);
			if (!L[d]) for (var x = 0; x <= d; x++) L[x] || (L[x] = {});
			(L[d].vx != ce || L[d].vy != b || L[d].el !== p) && (L[d].el = p, L[d].vx = ce, L[d].vy = b, clearInterval(L[d].pid), (ce != 0 || b != 0) && (l = !0, L[d].pid = setInterval(function() {
				r && this.layer === 0 && I.active._onTouchMove(Jt);
				var t = L[this.layer].vy ? L[this.layer].vy * s : 0, n = L[this.layer].vx ? L[this.layer].vx * s : 0;
				typeof u == "function" && u.call(I.dragged.parentNode[E], n, t, e, Jt, L[this.layer].el) !== "continue" || Fe(L[this.layer].el, n, t);
			}.bind({ layer: d }), 24))), d++;
		} while (t.bubbleScroll && f !== c && (f = ke(f, !1)));
		Gt = l;
	}
}, 30), en = function(e) {
	var t = e.originalEvent, n = e.putSortable, r = e.dragEl, i = e.activeSortable, a = e.dispatchSortableEvent, o = e.hideGhostForTarget, s = e.unhideGhostForTarget;
	if (t) {
		var c = n || i;
		o();
		var l = t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t, u = document.elementFromPoint(l.clientX, l.clientY);
		s(), c && !c.el.contains(u) && (a("spill"), this.onSpill({
			dragEl: r,
			putSortable: n
		}));
	}
};
function tn() {}
tn.prototype = {
	startIndex: null,
	dragStart: function(e) {
		this.startIndex = e.oldDraggableIndex;
	},
	onSpill: function(e) {
		var t = e.dragEl, n = e.putSortable;
		this.sortable.captureAnimationState(), n && n.captureAnimationState();
		var r = we(this.sortable.el, this.startIndex, this.options);
		r ? this.sortable.el.insertBefore(t, r) : this.sortable.el.appendChild(t), this.sortable.animateAll(), n && n.animateAll();
	},
	drop: en
}, v(tn, { pluginName: "revertOnSpill" });
function nn() {}
nn.prototype = {
	onSpill: function(e) {
		var t = e.dragEl, n = e.putSortable || this.sortable;
		n.captureAnimationState(), t.parentNode && t.parentNode.removeChild(t), n.animateAll();
	},
	drop: en
}, v(nn, { pluginName: "removeOnSpill" }), I.mount(new Xt()), I.mount(nn, tn);
//#endregion
//#region ../../node_modules/.pnpm/@vueuse+integrations@14.2.1_axios@1.15.0_sortablejs@1.15.7_vue@3.5.30_typescript@5.5.4_/node_modules/@vueuse/integrations/dist/useSortable-Cc5LKbDD.js
function rn(t, n, r = {}) {
	let i, { document: a = d, watchElement: o = !1, ...s } = r, c = { onUpdate: (e) => {
		sn(n, e.oldIndex, e.newIndex, e);
	} }, l = e(() => typeof t == "string" ? a?.querySelector(t) : m(t)), h = () => {
		i?.destroy(), i = void 0;
	}, ee = (e) => {
		!e || i !== void 0 || (i = new I(e, {
			...c,
			...s
		}));
	}, g = () => {
		let e = l.value;
		e && ee(e);
	}, te = (e, t) => {
		if (t !== void 0) i?.option(e, t);
		else return i?.option(e);
	}, _;
	return o && typeof t != "string" ? _ = u(l, (e) => {
		h(), e && ee(e);
	}, {
		immediate: !0,
		flush: "post"
	}) : f(g), p(() => {
		_?.(), h();
	}), {
		stop: () => {
			h();
		},
		start: g,
		option: te
	};
}
function an(e, t, n) {
	let r = e.children[n];
	e.insertBefore(t, r);
}
function on(e) {
	e.parentNode && e.parentNode.removeChild(e);
}
function sn(e, r, i, a = null) {
	a != null && (on(a.item), an(a.from, a.item, r));
	let o = t(e), s = o ? [...c(e)] : c(e);
	if (i >= 0 && i < s.length) {
		let t = s.splice(r, 1)[0];
		n(() => {
			s.splice(i, 0, t), o && (e.value = s);
		});
	}
}
//#endregion
//#region src/useDraggableSort/useDraggableSort.ts
var cn = (e, t, r = {}) => {
	let { onReorder: i, handleClass: a, ghostClass: o = "drag-ghost", animation: c = 150 } = r, l = s([...t.value]);
	return u(t, (e) => {
		l.value = [...e];
	}), rn(e, l, {
		handle: a,
		ghostClass: o,
		animation: c,
		onUpdate: (e) => {
			let t = e.oldIndex, r = e.newIndex;
			t === void 0 || r === void 0 || (sn(l, t, r, e), n(() => {
				i?.([...l.value], t, r);
			}));
		}
	}), { list: l };
}, ln = a({});
function un() {
	let e = ([e, t]) => {
		let n = ee(), r = ee(e), i = ee(t);
		return t ? e ? n.isBetween(r, i) : n.isBefore(i) : n.isAfter(r);
	}, t = (t) => {
		let n = {}, r = te.flatten(t);
		return Object.entries(r).forEach(([t, r]) => {
			let i = t;
			if (!Array.isArray(r)) {
				n[i] = r;
				return;
			}
			let [a, o] = r;
			n[i] = e([a, o]);
		}), n;
	}, n = () => {
		let e = {}, t = [];
		for (let e = 0; e < localStorage.length; e++) {
			let n = localStorage.key(e);
			/* c8 ignore if - this is an edge case where localStorage.key(i) returns null */
			n && t.push(n);
		}
		return t.filter((e) => e.startsWith("features.")).forEach((t) => {
			let n = t.replace("features.", "");
			e[n] = localStorage.getItem(t) === "true";
		}), e;
	};
	return {
		features: o(ln),
		loadFeatures: (e) => {
			let r = t(e), i = n();
			Object.keys(ln).forEach((e) => delete ln[e]), Object.assign(ln, {
				...r,
				...i
			});
		},
		isFeatureActive: (e) => ln[e] ?? !1
	};
}
//#endregion
//#region src/useFilterQuery/index.ts
var dn = (e, t, n, r = "watch") => {
	r === "watch" && u(e, async () => {
		await i();
	}, { deep: !0 });
	let i = async () => {
		let r = n.currentRoute.value.query, i = l(e), a = {};
		Object.keys(i).forEach((e) => {
			let n = t.value.find((t) => t.name === e)?.type;
			if (n === "checkbox") {
				let t = i[e];
				a[e] = t.length ? t.join(";") : void 0;
				return;
			}
			if (n === "radio") {
				let t = i[e];
				a[e] = t ? String(t) : void 0;
				return;
			}
			if (n === "number") {
				let t = i[e];
				a[e] = t ? String(t) : void 0;
				return;
			}
			if (n === "dateRange") {
				let t = i[e], n = t?.from ? t.from.toISOString().split("T")[0] : "", r = t?.to ? t.to.toISOString().split("T")[0] : "";
				a[e] = n.length || r.length ? `${n};${r}` : void 0;
				return;
			}
		}), await n.replace({ query: {
			...r,
			...a
		} });
	}, a = () => {
		let r = n.currentRoute.value.query;
		if (t.value.filter((e) => r[e.name] !== void 0).length === 0) return;
		let i = {};
		t.value.forEach((e) => {
			let t = r[e.name], n = {
				checkbox: [],
				number: null,
				radio: null,
				dateRange: {
					from: null,
					to: null
				}
			};
			if (t === void 0) {
				i[e.name] = n[e.type];
				return;
			}
			if (e.type === "checkbox") {
				let n = t.split(";").filter((t) => e.options.find((e) => e.value === t));
				i[e.name] = n;
				return;
			}
			if (e.type === "number") {
				let n = Number(t);
				i[e.name] = Number.isNaN(n) ? null : n;
				return;
			}
			if (e.type === "radio") {
				let n = t, r = Number(n), a = e.options.find((e) => e.value === n || e.value === r);
				i[e.name] = a?.value ?? null;
			}
			if (e.type === "dateRange") {
				let n = t ? t.split(";") : [], r = new Date(n[0]), a = new Date(n[1]), o = (e) => !isNaN(e.getTime());
				i[e.name] = {
					from: o(r) ? r : null,
					to: o(a) ? a : null
				};
			}
		}), e.value = i;
	};
	return a(), {
		setFiltersToUrl: i,
		getFiltersFromUrl: a
	};
}, R = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18
}, z = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE"
};
R.Dhl, R.Instabox, R.PostNl, z.PostNl, R.Bpost, z.Bpost, R.CheapCargo, z.CheapCargo, R.Dpd, z.Dpd, R.Instabox, z.Instabox, R.Dhl, z.Dhl, R.Bol, z.Bol, R.Ups, z.Ups, R.DhlForYou, z.DhlForYou, R.DhlParcelConnect, z.DhlParcelConnect, R.DhlEuroPlus, z.DhlEuroPlus, R.UpsStandard, z.UpsStandard, R.UpsExpressSaver, z.UpsExpressSaver, R.Gls, z.Gls, R.Brt, z.Brt, R.Trunkrs, z.Trunkrs, R.InPost, z.InPost, R.PosteItaliane, z.PosteItaliane, R.PostNl, z.POSTNL, R.Bpost, z.BPOST, R.CheapCargo, z.CHEAP_CARGO, R.Dpd, z.DPD, R.Instabox, z.INSTABOX, R.Dhl, z.DHL, R.Bol, z.BOL, R.Ups, z.UPS, R.DhlForYou, z.DHL_FOR_YOU, R.DhlParcelConnect, z.DHL_PARCEL_CONNECT, R.DhlEuroPlus, z.DHL_EUROPLUS, R.UpsStandard, z.UPS_STANDARD, R.UpsExpressSaver, z.UPS_EXPRESS_SAVER, R.Gls, z.GLS, R.Brt, z.BRT, R.Trunkrs, z.TRUNKRS, R.InPost, z.INPOST, R.PosteItaliane, z.POSTE_ITALIANE, z.PostNl, R.PostNl, z.POSTNL, R.PostNl, z.Bpost, R.Bpost, z.BPOST, R.Bpost, z.CheapCargo, R.CheapCargo, z.CHEAP_CARGO, R.CheapCargo, z.Dpd, R.Dpd, z.DPD, R.Dpd, z.Instabox, R.Instabox, z.Dhl, R.Dhl, z.BolCom, R.Bol, z.Bol, R.Bol, z.BOL, R.Bol, z.Ups, R.Ups, z.DhlForYou, R.DhlForYou, z.DHL_FOR_YOU, R.DhlForYou, z.DhlParcelConnect, R.DhlParcelConnect, z.DHL_PARCEL_CONNECT, R.DhlParcelConnect, z.DhlEuroPlus, R.DhlEuroPlus, z.DHL_EUROPLUS, R.DhlEuroPlus, z.UpsStandard, R.UpsStandard, z.UPS_STANDARD, R.UpsStandard, z.UpsExpressSaver, R.UpsExpressSaver, z.UPS_EXPRESS_SAVER, R.UpsExpressSaver, z.Gls, R.Gls, z.GLS, R.Gls, z.Brt, R.Brt, z.BRT, R.Brt, z.Trunkrs, R.Trunkrs, z.TRUNKRS, R.Trunkrs, z.InPost, R.InPost, z.INPOST, R.InPost, z.PosteItaliane, R.PosteItaliane, z.POSTE_ITALIANE, R.PosteItaliane;
//#endregion
//#region ../types/dist/index.js
var B = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
B.Austria, B.Belgium, B.Bulgaria, B.Croatia, B.Cyprus, B.CzechRepublic, B.Denmark, B.Estonia, B.Finland, B.France, B.Germany, B.Greece, B.Hungary, B.Ireland, B.Italy, B.Latvia, B.Lithuania, B.Luxembourg, B.Malta, B.Netherlands, B.Poland, B.Portugal, B.Romania, B.Slovakia, B.Slovenia, B.Spain, B.Sweden, Object.values(B), B.Angola, B.AntiguaAndBarbuda, B.Aruba, B.Bahamas, B.Belize, B.Benin, B.Bermuda, B.BonaireSintEustatiusAndSaba, B.Botswana, B.BurkinaFaso, B.Burundi, B.Cameroon, B.CanaryIslands, B.CentralAfricanRepublic, B.Comoros, B.CongoBrazzaville, B.CongoKinshasa, B.CoteDIvoire, B.Curacao, B.Djibouti, B.Dominica, B.DutchAntilles, B.EquatorialGuinea, B.Eritrea, B.Fiji, B.Gabon, B.Gambia, B.Ghana, B.Grenada, B.Guyana, B.HongKong, B.Kiribati, B.KoreaPeoplesDemocraticRepublic, B.Macao, B.Malawi, B.Mali, B.Mauritania, B.Nauru, B.Qatar, B.Rwanda, B.SaintKittsAndNevis, B.SaoTomeAndPrincipe, B.Seychelles, B.SierraLeone, B.SintMaarten, B.Suriname, B.SyrianArabRepublic, B.TimorLeste, B.Togo, B.Tonga, B.Tuvalu, B.Uganda, B.UnitedArabEmirates, B.Vanuatu, B.Yemen, B.Zimbabwe, B.Austria, B.Belgium, B.Bulgaria, B.Croatia, B.CzechRepublic, B.Estonia, B.Finland, B.France, B.Germany, B.Greece, B.Hungary, B.Ireland, B.Italy, B.Latvia, B.Lithuania, B.Luxembourg, B.Malta, B.Netherlands, B.Portugal, B.Romania, B.Slovakia, B.Slovenia, B.Spain, B.UnitedKingdom, B.Denmark, B.Germany, B.Sweden;
var V = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, H = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, fn = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
V.EarlyMorning, H.EarlyMorning, V.Morning, H.Morning, V.Standard, H.Standard, V.Evening, H.Evening, V.Pickup, H.Pickup, V.PickupExpress, H.PickupExpress, V.SameDayDelivery, H.SameDayDelivery, V.Express, H.Express, H.EarlyMorning, V.EarlyMorning, H.Morning, V.Morning, H.Standard, V.Standard, H.Evening, V.Evening, H.Pickup, V.Pickup, H.PickupExpress, V.PickupExpress, H.SameDayDelivery, V.SameDayDelivery, H.Express, V.Express, V.EarlyMorning, fn.EarlyMorning, V.Morning, fn.Morning, V.Standard, fn.Standard, V.Evening, fn.Evening, V.Pickup, fn.Pickup, V.PickupExpress, fn.PickupExpress, V.SameDayDelivery, fn.SameDayDelivery, V.Express, fn.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var pn = {
	Registered: 0,
	HandedToCarrier: 3,
	Sorting: 4,
	Distribution: 5,
	Delivered: 7
}, U = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, W = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
W.Sunday, U.Sunday, W.Monday, U.Monday, W.Tuesday, U.Tuesday, W.Wednesday, U.Wednesday, W.Thursday, U.Thursday, W.Friday, U.Friday, W.Saturday, U.Saturday, U.Sunday, W.Sunday, U.Monday, W.Monday, U.Tuesday, W.Tuesday, U.Wednesday, W.Wednesday, U.Thursday, W.Thursday, U.Friday, W.Friday, U.Saturday, W.Saturday;
var mn = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
mn.Bytes, mn.Kilobytes, mn.Megabytes, mn.Gigabytes, mn.Terabytes;
var hn = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, gn = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
hn.Bol, gn.Bol, hn.Exact, gn.Exact, hn.Amazon, gn.Amazon, hn.Wix, gn.Wix, hn.ExactDe, gn.ExactDe, hn.Etsy, gn.Etsy, gn.Bol, hn.Bol, gn.Exact, hn.Exact, gn.Amazon, hn.Amazon, gn.Wix, hn.Wix, gn.ExactDe, hn.ExactDe, gn.Etsy, hn.Etsy;
var G = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, K = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
G.Unpaid, K.Unpaid, G.Due, K.Due, G.DuePrepayment, K.DuePrepayment, G.Reminder1, K.Reminder1, G.Reminder2, K.Reminder2, G.Dun, K.Dun, G.Collection, K.Collection, G.Instalments, K.Instalments, G.PaymentArrangement, K.PaymentArrangement, G.Dispute, K.Dispute, G.LegalProcedure, K.LegalProcedure, G.Insolvency, K.Insolvency, G.WriteOff, K.WriteOff, G.Pending, K.Pending, G.Cancelled, K.Cancelled, G.Paid, K.Paid, G.PaidOnline, K.PaidOnline, G.PaidAutomatic, K.PaidAutomatic, G.PaidCredit, K.PaidCredit, G.PaidZeroItems, K.PaidZeroItems, G.InvoiceWith0InvoiceItemsPaidZeroBalance, K.PaidZeroBalance, G.Due, G.Reminder1, G.Reminder2, G.Dun, G.Collection, G.Instalments, G.PaymentArrangement, G.Dispute, G.Paid, G.PaidOnline, G.PaidAutomatic, G.PaidCredit, G.PaidZeroItems;
var _n = {
	Info: "info",
	Success: "success",
	Warning: "warning",
	Error: "alert"
}, vn = { Toaster: "toaster" }, yn = {
	Asc: "ASC",
	Desc: "DESC"
}, bn = {
	Gram: "g",
	Kilogram: "kg"
};
bn.Gram, bn.Kilogram;
var xn = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
xn.Millimeter, xn.Centimeter, xn.Meter;
var Sn = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, q = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Cn = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Cn.Light, q.Light, Cn.Start, q.Start, Cn.Plus, q.Plus, Cn.Premium, q.Premium, Cn.Max, q.Max, q.Light, Cn.Light, q.Start, Cn.Start, q.Plus, Cn.Plus, q.Premium, Cn.Premium, q.Max, Cn.Max;
var wn = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Tn = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
wn.Start, Tn.Start, wn.Plus, Tn.Plus, wn.Premium, Tn.Premium, wn.Max, Tn.Max, Tn.Start, wn.Start, Tn.Plus, wn.Plus, Tn.Premium, wn.Premium, Tn.Max, wn.Max;
var En = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Dn = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
En.Start, Dn.Start, En.Plus, Dn.Plus, En.Premium, Dn.Premium, En.Max, Dn.Max, Dn.Start, En.Start, Dn.Plus, En.Plus, Dn.Premium, En.Premium, Dn.Max, En.Max;
var On = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, kn = {
	Light: q.Light,
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
On.Light, kn.Light, On.Start, kn.Start, On.Plus, kn.Plus, On.Premium, kn.Premium, On.Max, kn.Max, kn.Light, On.Light, kn.Start, On.Start, kn.Plus, On.Plus, kn.Premium, On.Premium, kn.Max, On.Max;
var An = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, jn = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
An.Start, jn.Start, An.Plus, jn.Plus, An.Premium, jn.Premium, An.Max, jn.Max, jn.Start, An.Start, jn.Plus, An.Plus, jn.Premium, An.Premium, jn.Max, An.Max;
var J = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Mn = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Y = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
J.MyParcel, Mn.MyParcel, J.Flespakket, Mn.Flespakket, J.SendMyParcel, Mn.SendMyParcel, J.MyParcelIt, Mn.MyParcelIt, J.DeliverDutch, Mn.DeliverDutch, J.PostNlPlugin, Mn.PostNlPlugin, J.MyParcel, Y.MyParcelNl, J.Flespakket, Y.MyParcelNl, J.SendMyParcel, Y.MyParcelBe, J.MyParcelIt, Y.MyParcelIt, J.DeliverDutch, Y.DeliverDutch, J.PostNlPlugin, Y.PostNlPlugin, Y.MyParcelNl, J.MyParcel, Y.MyParcelBe, J.SendMyParcel, Y.MyParcelIt, J.MyParcelIt;
var Nn = {
	[Y.MyParcelNl]: {
		[Sn.HomeCountry]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[B.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[Sn.Eu]: [
			0,
			5e3,
			5e4
		],
		[Sn.Row]: [
			0,
			5e3,
			5e4
		],
		[B.Belgium]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		]
	},
	[Y.MyParcelBe]: {
		[Sn.HomeCountry]: [0, 5e4],
		[B.Belgium]: [0, 5e4],
		[B.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[Sn.Eu]: [
			0,
			5e3,
			5e4
		],
		[Sn.Row]: [
			0,
			5e3,
			5e4
		]
	}
}, Pn = { [Y.MyParcelBe]: {
	[Sn.HomeCountry]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[B.Belgium]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[Sn.Eu]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[Sn.Row]: [
		0,
		5e4,
		25e4,
		5e5
	]
} }, Fn = { [Y.MyParcelNl]: {
	[Sn.HomeCountry]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[B.Netherlands]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[Sn.Eu]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[Sn.Row]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, In = { [Y.MyParcelNl]: {
	[Sn.HomeCountry]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[B.Netherlands]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[B.Belgium]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[B.Luxembourg]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, Ln = {
	[R.Bpost]: Pn,
	[R.PostNl]: Nn,
	[R.DhlForYou]: Fn,
	[R.DhlParcelConnect]: Fn,
	[R.DhlEuroPlus]: Fn,
	[R.Ups]: In,
	[R.UpsStandard]: In,
	[R.UpsExpressSaver]: In
}, X = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Z = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
X.Package, Z.Package, X.Mailbox, Z.Mailbox, X.Letter, Z.Letter, X.DigitalStamp, Z.DigitalStamp, X.Pallet, Z.Pallet, X.PackageSmall, Z.PackageSmall, X.Envelope, Z.Envelope, Z.Package, X.Package, Z.Mailbox, X.Mailbox, Z.Letter, X.Letter, Z.DigitalStamp, X.DigitalStamp, Z.Pallet, X.Pallet, Z.PackageSmall, X.PackageSmall, Z.Envelope, X.Envelope;
var Rn = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
X.Package, Rn.PACKAGE, X.Mailbox, Rn.MAILBOX, X.Letter, Rn.UNFRANKED, X.DigitalStamp, Rn.DIGITAL_STAMP, X.Pallet, Rn.PALLET, X.PackageSmall, Rn.SMALL_PACKAGE, X.Envelope, Rn.ENVELOPE;
var Q = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Q.PendingConcept, Q.PendingRegistered, Q.EnrouteHandedToCarrier, Q.EnrouteSorting, Q.EnrouteDistribution, Q.DeliveredAtCustoms, Q.DeliveredAtRecipient, Q.DeliveredPackagePickedUp, Q.DeliveredReturnShipmentPackagePickedUp, Q.DeliveredAtAgreedLocation, Q.PrintedLetter, Q.PrintedDigitalStamp, Q.InactiveConcept, Q.InactiveRegistered, Q.InactiveEnrouteHandedToCarrier, Q.InactiveEnrouteSorting, Q.InactiveEnrouteDistribution, Q.InactiveEnrouteCustoms, Q.InactiveDeliveredAtRecipient, Q.InactiveDeliveredReadyForPickup, Q.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/useInsurance/index.ts
function zn() {
	return {
		createInsuranceOptions: (e, t) => e.reduce((e, n) => typeof t == "number" && n > t ? e : n === 0 ? (e.push({
			label: "common.none",
			value: n
		}), e) : (e.push({
			label: "insurance.insuredFor",
			translateParams: { amount: g.currency.format(n, {
				minimumFractionDigits: 0,
				maximumFractionDigits: 0
			}) },
			value: n
		}), e), []),
		getInsurance: ({ region: e = "", cc: t = "", carrierId: n, propositionKey: r }) => Ln?.[n]?.[r]?.[t] ?? Ln?.[n]?.[r]?.[e] ?? []
	};
}
//#endregion
//#region src/useNotification/index.ts
var Bn = s([]), Vn = s(0), Hn = 6e3;
function Un() {
	let e = ({ id: e, variant: n = _n.Info, canClose: r, withShadow: i, body: a, title: o, timeout: s = Hn, location: c = vn.Toaster }) => {
		let l = e;
		l ||= (Vn.value++, Vn.value.toString()), Bn.value.unshift({
			id: l,
			body: a,
			variant: n,
			title: o,
			timeout: s,
			location: c,
			canClose: r,
			withShadow: i
		}), s && setTimeout(() => {
			t(l);
		}, s);
	}, t = (e) => {
		Bn.value = Bn.value.filter((t) => t.id !== e);
	};
	return {
		notifications: o(Bn),
		addNotification: e,
		removeNotification: t,
		clearNotifications: () => {
			Bn.value = [];
		}
	};
}
//#endregion
//#region src/usePointer/index.ts
function Wn() {
	let e = s(-1), t = (t) => {
		e.value = t;
	};
	return {
		pointer: o(e),
		updatePointer: t,
		resetPointer: () => {
			t(-1);
		},
		incrementPointer: (n) => {
			let r = n.length - 1;
			e.value >= r || t(e.value + 1);
		},
		decrementPointer: () => {
			e.value < 0 || t(e.value - 1);
		}
	};
}
//#endregion
//#region src/useResetTree/ResetTreeControl.symbol.ts
var Gn = Symbol("ResetTreeControl"), Kn = (e, t, r, a) => {
	let o = s([]), c = () => o.value.forEach((e) => e.pause()), l = () => o.value.forEach((e) => e.resume()), u = async (e) => {
		c();
		try {
			await e();
		} finally {
			await n(), l();
		}
	}, d = (n) => {
		let i = JSON.parse(JSON.stringify(e));
		r[n].forEach((e) => {
			let n = e.split("."), r = i, a = t;
			n.forEach((e, t) => {
				t === n.length - 1 ? r[e] = a[e] : (r = r[e], a = a[e]);
			});
		}), a ? a(i, !1) : Object.assign(e, i);
	}, f = () => {
		Object.keys(r).forEach((e) => {
			d(e);
		});
	}, p = () => {
		Object.keys(r).forEach((t) => {
			let r = h(() => te.get(e, t), async () => {
				c(), d(t), await n(), l();
			});
			o.value.push(r);
		});
	}, m = () => {
		o.value.forEach((e) => e.stop()), o.value = [];
	};
	return i(() => {
		m();
	}), {
		watchers: o,
		resetFields: d,
		runWithoutResets: u,
		pauseResets: c,
		resumeResets: l,
		initResetTreeWatchers: p,
		executeResetTree: f,
		stopResetTreeWatchers: m
	};
};
//#endregion
//#region src/useResize/index.ts
function qn() {
	let e = s([]), t = (t) => {
		e.value.push(t);
	}, n = (t) => {
		e.value = e.value.filter((e) => e !== t);
	}, a = new ResizeObserver((t) => {
		!t[0] || !e.value.length || e.value.forEach((e) => e());
	});
	return r(() => {
		a.observe(document.body);
	}), i(() => {
		a.disconnect();
	}), {
		watchResize: t,
		unwatchResize: n
	};
}
//#endregion
//#region src/useSortControl/useSortControl.ts
var $ = a({});
function Jn(t, n = {}, r = { keepOnUnmount: !1 }) {
	/* c8 ignore if - This just guards against invalid sortProps */
	$[t] || ($[t] = {}), n && ($[t] = a(n));
	let s = {
		[yn.Asc]: "ascending",
		[yn.Desc]: "descending"
	}, c = e(() => u()), l = e(() => d()), u = () => Object.keys($[t]).find((e) => $[t][e]) ?? void 0, d = () => Object.values($[t]).find((e) => e) ?? void 0, f = (e) => e === u() ? d() : void 0, p = (e) => {
		let n = $[t][e];
		return n ? s[n] : "none";
	}, m = (e) => {
		for (let n in $[t]) n !== e && ($[t][n] = null);
	};
	return r.keepOnUnmount || i(() => {
		/* c8 ignore if - This just guards against invalid sortProps */
		$[t] && delete $[t];
	}), {
		allSorters: o($),
		sorters: o($[t]),
		sort: c,
		order: l,
		sortByColumn: (e) => {
			m(e), $[t][e] === yn.Desc ? $[t][e] = null : $[t][e] === yn.Asc ? $[t][e] = yn.Desc : $[t][e] = yn.Asc;
		},
		getOrder: f,
		getOrderBy: d,
		getOrderAriaLabel: p
	};
}
//#endregion
//#region src/useStates/states.ts
var Yn = [
	{
		name: "Alberta",
		code: "AB"
	},
	{
		name: "British Columbia",
		code: "BC"
	},
	{
		name: "Manitoba",
		code: "MB"
	},
	{
		name: "New Brunswick",
		code: "NB"
	},
	{
		name: "Newfoundland and Labrador",
		code: "NL"
	},
	{
		name: "Nova Scotia",
		code: "NS"
	},
	{
		name: "Northwest Territories",
		code: "NT"
	},
	{
		name: "Nunavut",
		code: "NU"
	},
	{
		name: "Ontario",
		code: "ON"
	},
	{
		name: "Prince Edward Island",
		code: "PE"
	},
	{
		name: "Saskatchewan",
		code: "SK"
	},
	{
		name: "Quebec",
		code: "QC"
	},
	{
		name: "Yukon",
		code: "YT"
	}
], Xn = [
	{
		name: "Alabama",
		code: "AL"
	},
	{
		name: "Alaska",
		code: "AK"
	},
	{
		name: "Arizona",
		code: "AZ"
	},
	{
		name: "Arkansas",
		code: "AR"
	},
	{
		name: "California",
		code: "CA"
	},
	{
		name: "Colorado",
		code: "CO"
	},
	{
		name: "Connecticut",
		code: "CT"
	},
	{
		name: "Delaware",
		code: "DE"
	},
	{
		name: "Florida",
		code: "FL"
	},
	{
		name: "Georgia",
		code: "GA"
	},
	{
		name: "Hawaii",
		code: "HI"
	},
	{
		name: "Idaho",
		code: "ID"
	},
	{
		name: "Illinois",
		code: "IL"
	},
	{
		name: "Indiana",
		code: "IN"
	},
	{
		name: "Iowa",
		code: "IA"
	},
	{
		name: "Kansas",
		code: "KS"
	},
	{
		name: "Kentucky",
		code: "KY"
	},
	{
		name: "Louisiana",
		code: "LA"
	},
	{
		name: "Maine",
		code: "ME"
	},
	{
		name: "Maryland",
		code: "MD"
	},
	{
		name: "Massachusetts",
		code: "MA"
	},
	{
		name: "Michigan",
		code: "MI"
	},
	{
		name: "Minnesota",
		code: "MN"
	},
	{
		name: "Mississippi",
		code: "MS"
	},
	{
		name: "Missouri",
		code: "MO"
	},
	{
		name: "Montana",
		code: "MT"
	},
	{
		name: "Nebraska",
		code: "NE"
	},
	{
		name: "Nevada",
		code: "NV"
	},
	{
		name: "New Hampshire",
		code: "NH"
	},
	{
		name: "New Jersey",
		code: "NJ"
	},
	{
		name: "New Mexico",
		code: "NM"
	},
	{
		name: "New York",
		code: "NY"
	},
	{
		name: "North Carolina",
		code: "NC"
	},
	{
		name: "North Dakota",
		code: "ND"
	},
	{
		name: "Ohio",
		code: "OH"
	},
	{
		name: "Oklahoma",
		code: "OK"
	},
	{
		name: "Oregon",
		code: "OR"
	},
	{
		name: "Pennsylvania",
		code: "PA"
	},
	{
		name: "Rhode Island",
		code: "RI"
	},
	{
		name: "South Carolina",
		code: "SC"
	},
	{
		name: "South Dakota",
		code: "SD"
	},
	{
		name: "Tennessee",
		code: "TN"
	},
	{
		name: "Texas",
		code: "TX"
	},
	{
		name: "Utah",
		code: "UT"
	},
	{
		name: "Vermont",
		code: "VT"
	},
	{
		name: "Virginia",
		code: "VA"
	},
	{
		name: "Washington",
		code: "WA"
	},
	{
		name: "Washington DC",
		code: "DC"
	},
	{
		name: "West Virginia",
		code: "WV"
	},
	{
		name: "Wisconsin",
		code: "WI"
	},
	{
		name: "Wyoming",
		code: "WY"
	}
], Zn = () => ({
	getStates: (e) => {
		switch (e) {
			case B.UnitedStatesOfAmerica: return Xn;
			case B.Canada: return Yn;
			default: return [];
		}
	},
	hasStates: (e) => {
		switch (e) {
			case B.UnitedStatesOfAmerica:
			case B.Canada: return !0;
			default: return !1;
		}
	}
}), Qn = a(/* @__PURE__ */ new Set());
function $n() {
	return {
		startRowLoading: (e) => {
			let t = Array.isArray(e) ? e : [e];
			for (let e of t) Qn.add(e);
		},
		stopRowLoading: (e) => {
			let t = Array.isArray(e) ? e : [e];
			for (let e of t) Qn.delete(e);
		},
		isRowLoading: (e) => Qn.has(e)
	};
}
//#endregion
//#region src/useTableSelection/useTableSelection.ts
var er = a({}), tr = a({});
function nr(t) {
	er[t] || (er[t] = {}), tr[t] || (tr[t] = []);
	let n = (e) => {
		if (!e) {
			Object.keys(er[t]).forEach((e) => {
				er[t][e] = !1;
			});
			return;
		}
		tr[t].forEach((n) => {
			er[t][n] = e;
		});
	}, r = (e) => {
		er[t][e] = !er[t][e];
	}, i = (e) => {
		tr[t] = e;
	}, a = () => {
		let e = er[t];
		Object.keys(e).forEach((t) => {
			delete e[t];
		});
	}, s = e(() => !tr[t] || !tr[t].length ? 0 : Object.values(er[t]).filter((e) => e).length);
	return {
		allSelected: e(() => !tr[t] || Object.keys(tr[t]).length === 0 ? !1 : tr[t].every((e) => er[t][e])),
		selection: o(er[t]),
		selectedCount: s,
		select: r,
		setVisibleItems: i,
		toggleSelectAll: n,
		clearSelection: a
	};
}
//#endregion
//#region src/useToggle/index.ts
function rr() {
	let e = s(!1), t = (t) => {
		e.value = t;
	};
	return {
		toggle: o(e),
		updateToggle: t,
		toggleToggle: () => {
			t(!e.value);
		},
		toggleToTrue: () => {
			t(!0);
		},
		toggleToFalse: () => {
			t(!1);
		}
	};
}
//#endregion
//#region src/useTrackAndTrace/index.ts
function ir() {
	let e = (e, n) => {
		let r = e.status.current, i = t(e), a = n ? [
			{
				type: "header",
				description: n.registered,
				disabled: r < pn.Registered,
				status: pn.Registered
			},
			{
				type: "header",
				description: n.handedToCarrier,
				disabled: r < pn.HandedToCarrier,
				status: pn.HandedToCarrier
			},
			{
				type: "header",
				description: n.sorting,
				disabled: r < pn.Sorting,
				status: pn.Sorting
			},
			{
				type: "header",
				description: n.distribution,
				disabled: r < pn.Distribution,
				status: pn.Distribution
			},
			{
				type: "header",
				description: n.delivered,
				disabled: r < pn.Delivered,
				status: pn.Delivered
			}
		] : [], o;
		return o = a.length > 0 ? [...a, ...i].sort((e, t) => e.status - (t.type === "header" && t.status === pn.Delivered ? Infinity : t.status)) : [...i].sort((e, t) => e.date.localeCompare(t.date)), o;
	}, t = (e) => {
		let t = e.status.current, n = e.history.map((e) => ({
			type: "item",
			date: e.time,
			description: e.description,
			disabled: !1,
			status: e.status
		}));
		return n.push({
			type: "item",
			date: e.time,
			description: e.description,
			disabled: !1,
			status: t
		}), n;
	};
	return {
		getFormattedTrackAndTrace: e,
		getTrackAndTraceItems: t
	};
}
//#endregion
export { Gn as ResetTreeControlKey, cn as useDraggableSort, un as useFeatures, dn as useFilterQuery, zn as useInsurance, Un as useNotification, Wn as usePointer, Kn as useResetTree, qn as useResize, Jn as useSortControl, Zn as useStates, $n as useTableRowLoading, nr as useTableSelection, rr as useToggle, ir as useTrackAndTrace };
